/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Government_IdInputs */

const en_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Government ID`)
};

const es_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación gubernamental`)
};

const fr_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièce d'identité`)
};

const de_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behördlicher Ausweis`)
};

const ja_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`政府発行の身分証明書`)
};

const zh_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`政府颁发的身份证件`)
};

const ar_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هوية حكومية`)
};

const id_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu Identitas (KTP/Paspor)`)
};

const it_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento di Identità`)
};

const ru_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удостоверение личности`)
};

const pt_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento de Identidade`)
};

const ko_government_id = /** @type {(inputs: Government_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정부 발급 신분증`)
};

/**
* | output |
* | --- |
* | "Government ID" |
*
* @param {Government_IdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const government_id = /** @type {((inputs?: Government_IdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Government_IdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_government_id(inputs)
	if (locale === "es") return es_government_id(inputs)
	if (locale === "fr") return fr_government_id(inputs)
	if (locale === "de") return de_government_id(inputs)
	if (locale === "ja") return ja_government_id(inputs)
	if (locale === "zh") return zh_government_id(inputs)
	if (locale === "ar") return ar_government_id(inputs)
	if (locale === "id") return id_government_id(inputs)
	if (locale === "it") return it_government_id(inputs)
	if (locale === "ru") return ru_government_id(inputs)
	if (locale === "pt") return pt_government_id(inputs)
	return ko_government_id(inputs)
});